import React, { createContext, useState } from 'react';
import ConfirmationModal from './ConfirmationModal';
export const ConfirmationModalContext = /*#__PURE__*/createContext(null);

/**
 * Mounted once at the app root. Renders the single ConfirmationModal used by useConfirmationModal.
 */
export function ConfirmationModalProvider(_ref) {
  let {
    children
  } = _ref;
  const [request, setRequest] = useState(null);
  const close = () => setRequest(null);
  return /*#__PURE__*/React.createElement(ConfirmationModalContext.Provider, {
    value: setRequest
  }, children, /*#__PURE__*/React.createElement(ConfirmationModal, {
    request: request,
    onCancel: close
  }));
}